import { FC, invalidateQuery } from '../../../Services'

export const deleteForm = async (formId) => {
  const res = await FC.service('formsWeb').remove(formId)
  invalidateQuery(['formsWeb'])
  window.growl.show({ severity: 'success', summary: 'Success', detail: 'Eliminazione effettuata' })
  return res
}
